






















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DemoSort extends Vue {
  public dragOld = -1;
  public dragNew = -1;
  public dragLeft = true;

  public items: any[] = [];
  public list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  public dragClass(index: number) {
    return { 
      'dragging': this.dragOld === index, 
      'dragover': this.dragNew === index,
    };
  }

  public created() {
    this.items = this.list.map((item, i) => ({ id: i + 1, text: item }));
  }

  public onDragStart(index: number) {
    this.dragOld = index;
  }

  public onDragEnter(index: number) {
    this.dragNew = index;
    console.log('enter', index)
  }

  public onDragOver(index: number, event: DragEvent) {
    const target = event.target as HTMLDivElement;
    const rect = target.getBoundingClientRect();
    const middleX = rect.left + rect.width / 2;
    this.dragLeft = event.clientX < middleX;
  }

  public onDragLeave(index: number) {
    console.log('leave', index)
  }

  public onDragEnd() {
    if (this.dragOld !== -1 && this.dragNew !== -1) {
      const newItems = [...this.items];
      const added = newItems.splice(this.dragOld, 1)[0];
      newItems.splice(this.dragNew, 0, added);
      this.items = [...newItems];
    }
    this.dragOld = -1;
    this.dragNew = -1;
  }
}
